export default {
      id: "i-enter-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-enter",
      toString: function () {
        return this.url;
      }
    }